import React from 'react'
import {ModalBase} from '../../../../../components/Modals/ModalBase'

const ModalEliminar = (props: any) => {
  return (
    <ModalBase>
      <div className='modal-card'>
        <div className='modal-content'>
          <div className='w-layout-hflex'>
            <h3 className='card-title l'>{props.eliminar ? 'Eliminar Elemento' : 'Quitar todo'}</h3>
          </div>
          <div className='form-separator'></div>
          <p className='m'>
            {props.eliminar
              ? '¿Seguro que quieres eliminar este elemento? Esta acción no se puede deshacer.'
              : '¿Seguro que quieres quitar todos los elementos de esta lista? Esta acción no se puede deshacer.'}
          </p>
          <div className='form-separator'></div>
          <div className='w-layout-hflex button-actions'>
            <button
              className='m button transparent w-inline-block'
              onClick={props.closeModalEliminar}
            >
              <div>Cancelar</div>
            </button>
            <button className='m button delete w-inline-block' onClick={props.actionEliminar}>
              <div>{props.eliminar ? 'Eliminar' : 'Quitar todo'}</div>
            </button>
          </div>
        </div>
      </div>
    </ModalBase>
  )
}

export default ModalEliminar
